const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'travel';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'travel',
  POLICIES_LIST: 'policies',
  POLICY_DETAIL_RELATIVE: 'detail/:policyId',
  POLICY_DETAIL: 'policies/detail/:policyId',
};

export const generateFullModuleRoute = (route?: string): string => {
  return route
    ? `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`
    : `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Viajes',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-shield',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.POLICIES_LIST),
        title: 'Pólizas',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.POLICY_DETAIL),
    title: 'Detalle de la póliza',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.POLICIES_LIST
    ),
  },
];
